import { activityAtom } from "@Lib/jotai/activity";
import { ArrowRightIcon } from "@t8891/icon";
import { IKindsPcInfo } from "@Types/kindsum";
import { useHover, useLocalStorageState, useSafeState, useSetState } from "ahooks";
import { useAtom } from "jotai";
import React, { useEffect, useRef, useState } from "react";

const Item: React.FC<any> = ({ label, content }) => {
  return (
    <div className='flex gap-4 mt-2'>
      {!!label && <div className='text-[#999] whitespace-pre'>{label}：</div>}
      <div className='text-black' style={{ maxWidth: "230px" }}>
        {content}
      </div>
    </div>
  );
};

const arr = [
  { value: "cashDiscount", label: "現折" },
  { value: "loanDiscount", label: "貸款" },
  { value: "subsidyDiscount", label: "補貼" },
  { value: "warrantyDiscount", label: "保固" },
  { value: "insuranceDiscount", label: "保險" },
  { value: "maintenanceDiscount", label: "保養" },
  { value: "giftDiscount", label: "禮品" },
  { value: "otherDiscount", label: "其他" },
];

// 广告样式
const RosterItem: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  kindId: number;
  brandId: number;
}> = ({ factoryDiscount, kindId, brandId }) => {
  const { title } = factoryDiscount;

  return (
    <div
      id='KindSumRosterRightDiscount'
      className='w-262 h-68 -ml-1 bg-cover bg-no-repeat flex relative'
      onClick={() => {
        window.open(`/ask/price?b=${brandId}&k=${kindId}&source=綜述-領優惠`, "_blank");
      }}
      style={{
        backgroundImage: `url(https://photo.8891.com.tw/2024/10/15/1728962629706833.png)`,
        backgroundSize: "99%",
      }}
    >
      <div className='flex gap-10 text-[#FF4333]  w-78 flex-wrap px-6 py-10 items-center'>
        <div
          className='text-12 rounded-4 w-58 flex items-center justify-center h-20'
          style={{ border: "1px solid #FF4333" }}
        >
          廠商優惠
        </div>
      </div>
      <div className='flex py-10 px-8 flex-wrap items-center relative'>
        <div className='truncate flex gap-6 w-174'>
          <div className='whitespace-break-spaces'>
            <div className='text-black'>{title}</div>
          </div>
        </div>
        <div className='absolute right-0 bottom-0 text-right text-12 text-[#999] w-full pr-10'>更多</div>
      </div>
    </div>
  );
};

const HoverDiscount: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  activityStatus: number;
  expand: string;
  brandId: number;
  kindId: number;
  tcDiscount: string;
}> = ({ brandId, kindId, factoryDiscount, activityStatus, expand, tcDiscount }) => {
  const { remark, title, tag = "廠商優惠", roster } = factoryDiscount;

  const [params, setParams] = useState<any[]>([]);

  const getTopDiscounts = (factoryDiscount, configList, maxCount = 2) => {
    // 廠商優惠支持顯示2行，右側顯示箭頭圖標，鼠標移入懸浮顯示
    // （僅一行時居中顯示，不顯示箭頭圖標）
    let arr = configList
      .map(({ value, label }) => {
        const val = factoryDiscount[value];
        return !!val ? { label, value: val } : null;
      })
      .filter(Boolean);
    if (factoryDiscount.extra?.length) {
      arr = [...arr, ...factoryDiscount.extra];
    }

    return arr;
  };

  useEffect(() => {
    const result = getTopDiscounts(factoryDiscount, arr);
    setParams(result);
  }, [factoryDiscount]);
  return (
    <div
      className='w-350 flex justify-center  absolute top-74 -left-40 z-99 rounded-8 cursor-pointer'
      style={{ boxShadow: "0px 4px 20px 0px rgba(0,0,0,0.10)" }}
      onClick={() => {
        window.open(
          `/ask/price?b=${brandId}&k=${kindId}&source=${roster?.length > 0 ? "綜述-領優惠" : "綜述頁（新）-領取優惠"}`,
          "_blank",
        );
      }}
    >
      <div data-expand={expand} id={"OneBrand"} className='rounded-8 overflow-hidden w-full'>
        <img
          className='absolute left-[170px] -top-6 w-8 h-6'
          src='https://photo.8891.com.tw/2024/10/08/1728374259639673.png'
        />
        <div
          className={`w-full px-10 h-36 flex items-center ${title ? "justify-center" : "justify-start"}`}
          style={{
            background: "linear-gradient(180deg,#ffece9, #fff9f8)",
            borderBottom: "0.5px solid rgb(255 201 186 / 47%)",
          }}
        >
          <div className={`flex gap-8 text-14 items-center`}>
            {!!tag && (
              <div className='bg-[#FFDFD6] text-12 whitespace-pre rounded-4 w-58 flex items-center justify-center h-20 leading-20 text-[#D92A21]'>
                {tag}
              </div>
            )}
            <span className='font-[500]'>{title}</span>
          </div>
        </div>
        <div className='p-10 bg-[#FFFDFC] flex flex-wrap gap-10'>
          <div className='flex gap-10 text-12'>
            <div className='grid gap-6' style={{ maxWidth: "260px" }}>
              {params.map((item: any, index: number) => (
                <Item label={item.label} content={item.value} key={index} />
              ))}
            </div>
          </div>

          <div className='w-350 text-right text-10 text-[#999] pl-66'>{remark}</div>
        </div>
      </div>
    </div>
  );
};

// A样式鼠标划入
const AItem: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  activityStatus: number;
  discountTitle: any;
  kindId: number;
  brandId: number;
  tcDiscount: string;
}> = ({ factoryDiscount, activityStatus, discountTitle, kindId, brandId, tcDiscount }) => {
  const [params, setParams] = useState<any[]>([]);

  const { tag = "廠商優惠", title = "" } = factoryDiscount;

  const getTopDiscounts = (factoryDiscount, configList, maxCount = 2) => {
    // 廠商優惠支持顯示2行，右側顯示箭頭圖標，鼠標移入懸浮顯示
    // （僅一行時居中顯示，不顯示箭頭圖標）
    let arr = configList
      .map(({ value, label }) => {
        const val = factoryDiscount[value];
        return !!val ? { label, value: val } : null;
      })
      .filter(Boolean)
      .slice(0, maxCount);
    if (factoryDiscount.extra?.length) {
      arr = [...arr, ...factoryDiscount.extra];
    }
    return arr;
  };

  useEffect(() => {
    const result = getTopDiscounts(factoryDiscount, arr);
    setParams(result);
  }, [factoryDiscount]);

  return (
    <div
      id='AKindSumRightDiscount'
      className='w-262 h-70 rounded-4  relative'
      style={{
        border: "1px solid #FFDFD6",
        background: `linear-gradient(150deg,#ffffff 17%, rgba(255,255,255,0.00) 63%)`,
      }}
      onClick={() => {
        window.open(`/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-領取優惠`, "_blank");
      }}
    >
      {!!tag && (
        <div
          className='w-78 h-26 text-12 flex justify-center items-center pr-5 absolute -top-4 -left-1 text-[#D92A21]'
          style={{
            backgroundImage: `url(https://photo.8891.com.tw/2025/04/18/1744957899032168.png)`,
            backgroundSize: "100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          {tag}
        </div>
      )}
      <div className={`flex gap-12 py-10 px-8 flex-wrap items-center h-full relative`}>
        {!!factoryDiscount.title && params.length > 0 && (
          <img
            src='https://photo.8891.com.tw/2025/04/08/1744098461489400.png'
            alt=''
            width={16}
            height={16}
            className={`absolute right-2 ${!!title ? "top-26" : "top-0"}`}
          />
        )}
        {!!factoryDiscount.title ? (
          <div className={`truncate inline w-220 relative`}>
            <div className='inline mr-8'>{factoryDiscount.title}</div>
          </div>
        ) : (
          <>
            {Array.isArray(params) && params.length > 0 && (
              <div className={`w-220 flex flex-col truncate gap-y-4 pt-12`}>
                {params.map(
                  (item, index) =>
                    index < 2 && (
                      <div key={index} className='flex mr-8'>
                        {!!item.label && <div className='text-[#999] inline mr-4'>{item.label}：</div>}
                        <div className='text-black truncate w-220'>{item.value}</div>
                      </div>
                    ),
                )}
                {params.length > 1 && (
                  <img
                    src='https://photo.8891.com.tw/2025/04/08/1744098461489400.png'
                    alt=''
                    width={16}
                    height={16}
                    className='absolute right-2 bottom-0 top-0 m-auto'
                  />
                )}
                {/* {!!factoryDiscount["remark"] && params.length === 1 && <div className='inline text-[#999] text-12 truncate absolute bottom-4 right-6'>{factoryDiscount["remark"]}</div>} */}
              </div>
            )}
          </>
        )}
      </div>
      {!!factoryDiscount["remark"] && params.length === 1 && !factoryDiscount.title && (
        <div className='inline text-[#999] truncate absolute bottom-4 right-6'>{factoryDiscount["remark"]}</div>
      )}
    </div>
  );
};

const KindSumRightDiscount: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const { factoryDiscount, inquiry, brandId, kindId, tcDiscount } = data;
  const { roster } = factoryDiscount;
  const [params, setParams] = useState<any[]>([]);

  const [activityInfo, updateActivityInfo] = useAtom(activityAtom);

  const ref = useRef(null);
  const isHovering = useHover(ref);

  const [abTestValue, setAbTestValue] = useLocalStorageState<string | undefined>("kind-sum-discount-ab-test", {
    defaultValue: "",
  });

  useEffect(() => {
    updateActivityInfo();
  }, []);

  const getTopDiscounts = (factoryDiscount, configList, maxCount = 2) => {
    // 廠商優惠支持顯示2行，右側顯示箭頭圖標，鼠標移入懸浮顯示
    // （僅一行時居中顯示，不顯示箭頭圖標）
    let arr = configList
      .map(({ value, label }) => {
        const val = factoryDiscount[value];
        return !!val ? { label, value: val } : null;
      })
      .filter(Boolean)
      .slice(0, maxCount);
    if (factoryDiscount.extra?.length) {
      arr = [...arr, ...factoryDiscount.extra];
    }
    return arr;
  };

  useEffect(() => {
    const result = getTopDiscounts(factoryDiscount, arr);
    setParams(result);
  }, [factoryDiscount]);

  // 全部数据都没有，则不显示
  if (
    !tcDiscount &&
    !factoryDiscount.cashDiscount &&
    !factoryDiscount.loanDiscount &&
    !factoryDiscount.subsidyDiscount &&
    !factoryDiscount.warrantyDiscount &&
    !factoryDiscount.insuranceDiscount &&
    !factoryDiscount.maintenanceDiscount &&
    !factoryDiscount.giftDiscount &&
    factoryDiscount?.extra?.length === 0 &&
    !factoryDiscount.otherDiscount
  ) {
    return null;
  }

  return (
    <div className='h-82' ref={ref}>
      <div
        id={`${roster?.length === 0 ? "kind-sum-right-discount" : ""}`}
        data-expand={abTestValue}
        className='w-262 h-68 relative cursor-pointer'
      >
        {isHovering && params.length > (!!inquiry.discountTitle ? 0 : 1) && (
          <HoverDiscount
            expand={abTestValue || ""}
            factoryDiscount={factoryDiscount}
            activityStatus={activityInfo?.activityStatus}
            brandId={brandId}
            kindId={kindId}
            tcDiscount={tcDiscount}
          />
        )}

        <AItem
          factoryDiscount={factoryDiscount}
          activityStatus={activityInfo.activityStatus}
          discountTitle={inquiry.discountTitle}
          brandId={brandId}
          kindId={kindId}
          tcDiscount={tcDiscount}
        />
      </div>
    </div>
  );
};
export default KindSumRightDiscount;
